export default __webpack_public_path__ + "static/media/ThreedImageModel.2cefa9b4.png";